import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './core/auth-layout/auth-layout.component';
import { HomeLayoutComponent } from './core/home-layout/home-layout.component';
import { DomesCreateComponent } from './domes/domes-create/domes-create.component';
import { DomesListComponent } from './domes/domes-list/domes-list.component'; // Import DomesListComponent
import { UserManageComponent } from './cognito/user-manage/user-manage.component';
import { SuperAdminLayoutComponent } from './core/super-admin-layout/super-admin-layout.component';
import { ProjectAnalyticsComponent } from './projects/project-analytics/project-analytics.component';

import { AuthGuard, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard'; // Renamed AngularFireAuthGuard to AuthGuard

const redirectLoggedInToProjects = () => redirectLoggedInTo(['projects']); // Updated redirect function
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['auth/sign-in']);

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'projects' // Updated default redirect
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard], // Updated to AuthGuard
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      {
        path: 'projects',
        loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
      },
      // Add the new route for experiences list
      {
        path: ':clientId/projects/:projectId/experiences',
        component: DomesListComponent
      },
      // Add the new route for project analytics
      {
        path: ':clientId/projects/:projectId/analytics',
        component: ProjectAnalyticsComponent
      },
      {
        path: 'domes-create', // Keep domes-create if needed separately
        component: DomesCreateComponent,
      },
      {
        path: 'user-manage', 
        component: UserManageComponent,
      },
      {
        path: 'super-admin', 
        component: SuperAdminLayoutComponent,
      },
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    canActivate: [AuthGuard], // Updated to AuthGuard
    data: { authGuardPipe: redirectLoggedInToProjects }, // Use updated redirect function
    loadChildren: () => import('./cognito/cognito.module').then(m => m.CognitoModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
